import { pickBy } from "lodash-es";

// 返回不包含null、undefined、空串的对象
function cleanObject(obj) {
  const newObj = { ...obj }; // create a copy of obj
  const propNames = Object.getOwnPropertyNames(newObj);
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (
      newObj[propName] === null ||
      newObj[propName] === undefined ||
      newObj[propName] === ""
    ) {
      delete newObj[propName];
    }
  }
  return newObj;
}

function getFileName(headers) {
  let filename = "";
  const disposition = headers["content-disposition"];
  if (disposition && disposition.indexOf("attachment") !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }
  return filename;
}

const Local = {
  // 设置永久缓存
  set(key, val) {
    window.localStorage.setItem(key, JSON.stringify(val));
  },
  // 获取永久缓存
  get(key) {
    const json = window.localStorage.getItem(key);
    return JSON.parse(json) || {};
  },
  // 移除永久缓存
  remove(key) {
    window.localStorage.removeItem(key);
  },
  // 移除全部永久缓存
  clear() {
    window.localStorage.clear();
  },
};

export { cleanObject, getFileName, Local };
/**
 * 去除对象中的 falsy 值
 */
export const removeFalsy = (obj) => {
  return pickBy(obj, (value) => ![undefined, null, ""].includes(value));
};



// WEBPACK FOOTER //
// ./src/utils/utils.js